import React from 'react'

const Shop = () => {
  return (
    <><div className="shop">

      <div className=' container'>
        <div className="shop-text">
            <div>
                <h4>Free Delivery With</h4> 
                <h1>PIZZA OF THE DAY </h1>
                 <h5>Only 8.99 USD</h5>
                <div className='shop-btn'>
                    <a href="" className='btn btn-smart'>Call now</a>
                </div>
            </div>
        </div>

      </div>
    </div>
    </>
  )
}

export default Shop